export const GET_UX_JOURNEY_CONFIG = 'GET_JOURNEY_VARIABLES'
